import { HTMLAttributes } from "react"

export default function Mailgun(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
    >
      <path
        d="M32.066 19.956c-6.69 0-12.13 5.433-12.13 12.1s5.443 12.1 12.13 12.1 12.13-5.433 12.13-12.1-5.443-12.1-12.13-12.1zm-18.885 12.1c0-10.408 8.46-18.852 18.885-18.852S50.95 21.658 50.95 32.065c0 .72-.066 1.375-.13 2.03-.13 1.833 1.18 3.207 3.016 3.207 3.082 0 3.4-3.993 3.4-5.302 0-13.943-11.28-25.2-25.246-25.2S6.754 18.057 6.754 32 18.033 57.2 32 57.2c7.4 0 14.033-3.207 18.69-8.248l5.18 4.32c-5.836 6.546-14.36 10.67-23.87 10.67C14.295 63.944 0 49.608 0 32 0 14.326 14.36.056 32 .056 49.705.056 64 14.392 64 32c0 7.07-3.4 12.83-10.164 12.83-3.016 0-4.787-1.375-5.836-2.88-3.344 5.368-9.246 8.902-16.066 8.902-10.295.065-18.754-8.38-18.754-18.786zm18.885-5.564c3.082 0 5.574 2.487 5.574 5.498 0 3.077-2.492 5.564-5.574 5.564S26.492 35.077 26.492 32c.066-3.01 2.492-5.498 5.574-5.498z"
        fill="#c02126"
      />
    </svg>
  )
}
